module.exports = function (done, value) {
  return { value: value, done: !!done };
};



// WEBPACK FOOTER //
// ./C:/Users/Pili/AppData/Roaming/npm/~/pink/~/core-js/modules/_iter-step.js